import { get as _getValue } from "lodash-es";
import { getters } from "common/components/getters/getters";

import { captureException } from "extensions/sentry";
import { number, rate, amount } from "common/formats";
import strings from "common/strings";
import { references } from "common/helpers/references";
import moment from "moment";

export const table_mapper = function(fullView) {
    return function(field) {
        const column = {
            getter_ref: field.getter_ref,
            visible: field.collapsed_visible || fullView,
            cellOptions: Object.create(null),
            sortOptions: Object.create(null),
            batch: field.collapsed_visible ? "collapsed" : "expanded",
            css: []
        };
        
        const getter = getters.findById(field.getter_ref);
        if (!getter) {
            // Record the exception
            captureException(new Error("Getter match is not found"), {
                extra: {
                    getter_ref: field.getter_ref
                }
            });
        
            // And continue
            return {
                ...column,
                visible: false
            };
        }
        
        Object.assign(column, {
            id: getter.key,
            headerTooltip: getter.tooltip || getter.name,
            preFormat: (obj) => _getValue(obj, getter.key),
            sortOptions: { key: getter.key }
        });

        switch (field.getter_ref) {
        case "5ec7dc5375c262cf16068b0b": {
            column.section_ref = "settlements";
            break;
        }
        case "5b19997edabe69133a95efc6": {
            column.section_ref = "chargebacks";
            break;
        }
        case "5ec7dc5375c262cf16068b0e": {
            column.section_ref = "fees";
            break;
        }
        case "5ee7dd80e95679805509ac2c": {
            column.section_ref = "misc";
            break;
        }
        default: {
            break;
        }
        }

        if (field.getter_ref === "5b19997edabe69133a95efb2") {
            column.sortOptions = {};
        }

        if (field.getter_ref === "5ec7dc5375c262cf16068b0d") {
            column.css.push("net-sum medium-font");
        }

        if (getter.pivot && getter.valueType !== "date_time") {
            column.cellOptions.queryable = true;
            column.cellOptions.pivot_alias = getter.pivot_alias || getter.key;
        }

        if (["5ec7dc5375c262cf16068b0b", "5b19997edabe69133a95efc6", "5ec7dc5375c262cf16068b0e", "5ee7dd80e95679805509ac2c"].includes(field.getter_ref)) column.cellOptions.drilldown = true;

        if (getter.key?.search(/_utc/g) !== -1) {
            column.cellOptions.utc = true;
        }
        
        if (getter.decimals) {
            column.cellOptions.precision = getter.decimals;
        }

        if (field.plain) return column;

        switch (getter.valueType) {
        case "number": {
            column.preFormat = (obj) => number(_getValue(obj, getter.key), column.cellOptions?.precision);
            break;
        }
        case "rate": {
            column.preFormat = (obj) => rate(_getValue(obj, getter.key), column.cellOptions);
            break;
        }
        case "amount": {
            column.preFormat = (obj) => amount(_getValue(obj, getter.key), { currency: _getValue(obj, "stl_currency"), decimals: getter.decimals || 2 });
            column.css.push("align-right");
            break;
        }
        case "date_time": {
            column.preFormat = (obj) => {
                const value = _getValue(obj, getter.key);
                if (!value) return "--";
                const date = column.cellOptions.utc ? moment(value) : moment(value).local();
                // eslint-disable-next-line sentence-case/sentence-case
                return date.format(column.cellOptions.date_format || "ddd MMM D, YYYY");
            };
            break;
        }
        case "text": {
            column.preFormat = (obj) => {
                const content = _getValue(obj, getter.key);
                if (typeof content === "undefined") {
                    return "--";
                }
                
                if (content === strings.emptyTableCell) {
                    return content;
                }
                
                // if (field.alternateMapping) {
                //     return references.toAlias(content, field.alternateMapping) || strings.notAvailableValue;
                // }
                
                // Alternate mapping now uin references, specify second param as getter.id
                return references.toAlias(content, field.getter_ref) || "--";
            };
            break;
        }
        default: {
            break;
        }
        }

        return column;
    };
};

export const makeFieldMap = (pivots = {}, fields = []) => ({
    ...pivots,
    ...fields.reduce((memo, g) => {
        const getter = getters.findById(g);
        return {
            ...memo,
            [getter.key]: getter.name
        };
    }, Object.create(null))
});
